export default class EventBlock {

    constructor($view) {
        this.$view = $view;
        this.$content = this.$view.find('.js-content');
        this.$expandContent = this.$view.find('.js-expand-content');

        this.bind();
    }

    bind(){
        this.$expandContent.on('click', (e) => {
            e.preventDefault();
            this.$view.toggleClass('expanded');
        });

    }/*

    bind() {

        this.init();

        $(window).on('resize', (e) => {
           this.init();
        });

        this.$expandContent.on('click', (e) => {
            e.preventDefault();
           this.$view.toggleClass('expanded');
        });

    }

    init() {

        if (this.isClamped()) {
            this.$expandContent.show();
        } else {
            this.$expandContent.hide();
        }

    }

    isClamped() {
        return this.$content[0].scrollHeight > this.$content[0].clientHeight;
    }
*/
}